import { useDictionary } from './useDictionary';
import type { CommunityLinks } from '@/shared/types';

const useCommunityDictionary = () => {
  const {
    data: communityData,
    isLoading: isCommunityLoading,
    error: communityError,
  } = useDictionary<CommunityLinks>({
    dictionaryName: 'community',
  });

  return {
    communityData,
    isCommunityLoading,
    communityError,
  };
};

export { useCommunityDictionary };
